import { useEntity } from '@backstage/plugin-catalog-react';
import { makeStyles } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import MembersList, { MemberType, TeamTopologyStatus } from '.';
import { dhDockStore } from '../../../redux/store';
import { OwnershipCard } from '../../OwnershipCard/OwnershipCard';
import { GroupSecurityMetricsCard } from '../GroupSecurityMetrics/GroupSecurityMetricsCard';
import { InfoPage } from '../../../components/ui/Notifications';

import GroupProfileCard from '../../../components/GroupProfile';

const usestyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '30px',
  },
  editIcon: {
    fontSize: 24,
    cursor: 'pointer',
  },
  link: {
    position: 'absolute',
    top: 20,
    right: 20,
  },
});

const TeamOverviewPage = () => {
  const classes = usestyles();
  const { entity } = useEntity();
  const [hasIssues, setHasIssues] = useState(false);
  const [teamTopologyStatus, setTeamTopologyStatus] =
    useState<TeamTopologyStatus>('defined');
  const store = dhDockStore.getState();
  const { list } = store.entraIdGroups as any;
  const member_Type: MemberType[] = ['champions', 'core', 'contributor'];


  const teamData = list?.find(
    (x: { entraId: { entraid_team_objectid: string; type: string } }) =>
      x.entraId?.entraid_team_objectid?.toLowerCase() === entity?.metadata.annotations?.['graph.microsoft.com/group-id']?.toLowerCase()  );

  useEffect(() => {
    const interval = setInterval(() => {
      const element = document.querySelector('[title="Edit Metadata"]');
      const digitalHangarRootTitle = document.querySelector(
        '[title="group:default/dh_digitalhangarpeopleappgroups | Team | Entra ID: DH_DigitalHangarPeopleAppGroups"]',
      );

      let found = false;

      if (element && element instanceof HTMLElement) {
        element.style.display = 'none';
        found = true;
      }

      if (
        digitalHangarRootTitle &&
        digitalHangarRootTitle instanceof HTMLElement
      ) {
        digitalHangarRootTitle.style.display = 'none';
        found = true;
      }

      // Only stop the interval once both elements are hidden
      if (found) {
        clearInterval(interval);
      }
    }, 100);

    // Clean up on unmount
    return () => clearInterval(interval);
  }, []);

  const hasDataIssues = (data?: boolean) => {
    setHasIssues(data!);
  };

  const hasMissingTeamTopology = teamTopologyStatus === 'missing';

  return (
    <div className={classes.container}>
      <div style={{ position: 'relative' }}>
        <GroupProfileCard />

        <Link
          target="_blank"
          rel="noopener noreferrer"
          to={`https://lhg-dh.crm4.dynamics.com/main.aspx?appid=4af2fbc9-3e11-ef11-9f8a-6045bd8d1c97&pagetype=entityrecord&etn=lx_productteam&id=${teamData?.entraId?.uid??entity?.metadata.annotations?.['graph.microsoft.com/group-id']}`}
          className={classes.link}
        >
          <EditIcon color="primary" className={classes.editIcon} />
        </Link>
      </div>

      <div>
        {hasMissingTeamTopology && (
          <InfoPage
            type="info"
            message={
              <>
                No topology is defined for this team in People App. DH Dock
                cannot render the team topology until this data is available.
                <br />
                <br />
                <strong>What is wrong?</strong> The team topology field is empty
                in People App. Please update the team topology to one of the
                supported options in People App.
                <br />
                <br />
                Guidance:{' '}
                <a
                  href="https://dock.dh.lufthansa-group.com/docs/default/System/be26df2f-284c-f011-877a-7c1e527224bf/guides/how-to-ensure-peopleapp-dh-dock-membersysn/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    fontWeight: 700,
                    cursor: 'pointer',
                    textDecoration: 'underline',
                  }}
                >
                  <strong>How to ensure People App and DH Dock member sync</strong>
                </a>
              </>
            }
          />
        )}

        {!hasMissingTeamTopology && hasIssues && (
          <InfoPage
            type="info"
            message={
              <>
                {entity?.metadata?.name} has some data quality issues on people
                app. Please click{' '}
                <a
                  href="https://dock.dh.lufthansa-group.com/docs/default/System/be26df2f-284c-f011-877a-7c1e527224bf/guides/how-to-ensure-peopleapp-dh-dock-membersysn/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    fontWeight: 700,
                    cursor: 'pointer',
                    textDecoration: 'underline',
                  }}
                >
                  <strong>here</strong>
                </a>{' '}
                to see how to fix this.
              </>
            }
          />
        )}
      </div>

      <OwnershipCard />
      {member_Type.map((member, index) => (
        <MembersList
          key={index}
          memberType={member}
          name={entity.metadata.name as string}
          hasDataIsh={hasDataIssues}
          onTeamTopologyStatusChange={setTeamTopologyStatus}
        />
      ))}

      <GroupSecurityMetricsCard title="SonarQube Metrics" />
    </div>
  );
};

export default TeamOverviewPage;
